export const clearSessionExpiredFromUrl = (): void => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('userSessionExpired')) {
        return;
    }
    searchParams.delete('userSessionExpired');
    let newUrl = `${window.location.pathname}`;
    if (searchParams.toString().length > 0) {
        newUrl = `${window.location.pathname}?${searchParams}`;
    }
    window.history.pushState({ path: newUrl }, '', newUrl);
};
